module.exports = __webpack_public_path__ + "media/14.f3052e32.mp3";